import { Routes, Route } from "react-router-dom";

// ─── Pages ───────────────────────────────────────────────────────────────────
import About              from "./pages/About";
import Register           from "./pages/Register";
import ProfileInfo        from "./pages/Profileinfo";
import Login              from "./pages/Login";
import Rooms              from "./pages/Rooms";
import RoomDetail         from "./pages/RoomDetail";
import Profile            from "./pages/profile";
import ForgotPassword     from "./pages/ForgotPassword";
import ResetPassword      from "./pages/ResetPassword";
import VerifyOTP          from "./pages/VerifyOTP";
import Statuspage         from "./pages/Statuspage";
import Payment            from "./pages/Payment";
import OAuthCallback      from "./pages/OAuthCallback";
import BookingDetailPage  from "./pages/Bookingdetailpage";

// ─── Admin Pages ──────────────────────────────────────────────────────────────
import AdminDashboard        from "./admin/AdminDashboard";
import AdminRooms            from "./admin/AdminRooms";
import AdminCalendar         from "./admin/AdminCalendar";
import AdminCancellationPage from "./admin/Admincancellationpage";
import CheckIn               from "./admin/CheckIn";
import CheckOut              from "./admin/CheckOut";
import SlipVerificationPage  from "./admin/SlipVerificationPage";
import AdminUsers            from "./pages/AdminUsers";
import ReceiptEditor         from "./admin/ReceiptEditor";
import ReceiptArchive        from "./admin/ReceiptArchive";
import ServiceItems          from "./admin/ServiceItems";
import PaymentSettings       from "./admin/PaymentSettings";
import AdminReport           from "./admin/AdminReport";
import GuestRegistry         from "./admin/GuestRegistry";

// ─── Layouts / Guards / Navbars ───────────────────────────────────────────────
import ProtectedRoute  from "./components/ProtectedRoute";
import StaffLayout     from "./components/StaffLayout";
import RoleRedirect    from "./components/RoleRedirect";
import Navbar          from "./components/Navbar";
import NavbarStaff     from "./components/NavbarStaff";
import { NavbarAdmin } from "./components/NavbarAdmin";

import OAuthConsent from "./pages/OAuthConsent";
import { LanguageProvider } from "./context/LanguageContext";
import { BookingCartProvider } from "./context/BookingCartContext";
import "./App.css";

/* ─────────────────────────────────────────────────────────────
   Rooms Wrappers (Navbar อยู่นอก Rooms เหมือนเดิม)
───────────────────────────────────────────────────────────── */
function PublicRooms() {
  return <><Navbar /><Rooms /></>;
}
function StaffRoomsBooking() {
  return <><NavbarStaff /><Rooms /></>;
}
function AdminRoomsBooking() {
  return <><NavbarAdmin /><Rooms /></>;
}

/* ─────────────────────────────────────────────────────────────
   App
   RoomDetail และ Payment จัดการ Navbar ภายใน component เอง
   ผ่าน useNavbar() hook — ไม่ต้องมี wrapper แยก
───────────────────────────────────────────────────────────── */
function App() {
  return (
    <LanguageProvider>
    <BookingCartProvider>
    <Routes>
      <Route path="/oauth-consent" element={<OAuthConsent />} />
      {/* ══════════════════════════════════════════════════════════
          PUBLIC — ไม่ต้อง login
      ══════════════════════════════════════════════════════════ */}
      <Route path="/"                element={<RoleRedirect />} />
      <Route path="/about"           element={<About />} />
      <Route path="/register"        element={<Register />} />
      <Route path="/login"           element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-otp"      element={<VerifyOTP />} />
      <Route path="/reset-password"  element={<ResetPassword />} />
      <Route path="/oauth-callback"  element={<OAuthCallback />} />
      <Route path="/rooms"           element={<PublicRooms />} />

      {/* RoomDetail + Payment มี useNavbar() ข้างใน — ใช้ route เดียวได้เลย */}
      <Route path="/roomdetail/:id"  element={<RoomDetail />} />
      <Route path="/payment"         element={<Payment />} />

      {/* ══════════════════════════════════════════════════════════
          USER — ต้อง login (role: user | staff | admin)
      ══════════════════════════════════════════════════════════ */}
      <Route element={<ProtectedRoute allowedRoles={["user", "staff", "admin"]} />}>
        <Route path="/profileinfo" element={<ProfileInfo />} />
        <Route path="/profile"     element={<Profile />} />
        <Route path="/statuspage"  element={<Statuspage />} />
        <Route path="/booking/:id" element={<BookingDetailPage />} />
      </Route>

      {/* ══════════════════════════════════════════════════════════
          STAFF — role: staff | admin
      ══════════════════════════════════════════════════════════ */}
      <Route element={<ProtectedRoute allowedRoles={["staff", "admin"]} />}>
        <Route element={<StaffLayout />}>
          <Route path="/calendar"      element={<AdminCalendar />} />
          <Route path="/checkin"       element={<CheckIn />} />
          <Route path="/checkout"      element={<CheckOut />} />
          <Route path="/cancellations" element={<AdminCancellationPage showNavbar={false} />} />
          <Route path="/slips"         element={<SlipVerificationPage />} />
        </Route>
        {/* /booking ใช้ NavbarStaff — ไม่อยู่ใน StaffLayout เพื่อให้ Rooms ไม่มี navbar ซ้อน */}
        <Route path="/booking" element={<StaffRoomsBooking />} />
      </Route>

      {/* ══════════════════════════════════════════════════════════
          ADMIN — role: admin เท่านั้น
      ══════════════════════════════════════════════════════════ */}
      <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
        <Route path="/admin"               element={<AdminDashboard />} />
        <Route path="/admin/rooms"         element={<AdminRooms />} />
        <Route path="/admin/calendar"      element={<AdminCalendar />} />
        <Route path="/admin/cancellations" element={<AdminCancellationPage showNavbar={true} />} />
        <Route path="/admin/checkin"       element={<><NavbarAdmin /><CheckIn /></>} />
        <Route path="/admin/checkout"      element={<><NavbarAdmin /><CheckOut /></>} />
        <Route path="/admin/payments"      element={<><NavbarAdmin /><SlipVerificationPage /></>} />
        <Route path="/admin/booking"       element={<AdminRoomsBooking />} />
        <Route path="/admin/users"         element={<AdminUsers />} />
        <Route path="/admin/receipt"       element={<ReceiptEditor />} />
        <Route path="/admin/receipt-archive" element={<ReceiptArchive />} />
        <Route path="/admin/items"         element={<ServiceItems />} />
        <Route path="/admin/payment-settings" element={<PaymentSettings />} />
        <Route path="/admin/report"        element={<AdminReport />} />
        <Route path="/admin/guests"        element={<GuestRegistry />} />
      </Route>

    </Routes>
    </BookingCartProvider>
    </LanguageProvider>
  );
}

export default App;